export default __webpack_public_path__ + "static/media/igna.cca909ca.jfif";